import { apiFetch } from '../config/api';
import { abortDismissalSimulation } from './dismissalSimulation';

export async function startRealDismissal({ schoolId, token }) {
  const normalizedSchoolId = Number(schoolId);
  if (!normalizedSchoolId) {
    throw new Error('schoolId is required');
  }

  await apiFetch('/dismissal-status/start', {
    method: 'POST',
    body: JSON.stringify({ school_id: normalizedSchoolId }),
  }, token);
}

export async function endRealDismissal({ schoolId, token }) {
  const normalizedSchoolId = Number(schoolId);
  if (!normalizedSchoolId) {
    throw new Error('schoolId is required');
  }

  await abortDismissalSimulation({ schoolId: normalizedSchoolId });

  await apiFetch('/dismissal-status/end', {
    method: 'POST',
    body: JSON.stringify({ school_id: normalizedSchoolId }),
  }, token);
}
